import React, { useState } from 'react'
import { Field as FieldConf, getFieldLabel } from 'src/config'
import * as types from '../../../types'
import { InputLabel, OutlinedInput } from '@mui/material'
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const PasswordField: React.FC<{
    field: FieldConf,
    value?: types.SimpleValue,
    onChange: (value: types.Value) => void,
    disabled?: boolean
    errors?: types.Error[],
    // options?: types.EntityOptions
}> = ({
    field,
    value,
    onChange,
    disabled = false,
    errors = [],
    // options
}) => {
        const [show, setShow] = useState<boolean>(false);
        const { name, label, description, required } = field;

        return (
            <>
                <InputLabel
                    htmlFor={'field-' + name}
                    sx={{ color: theme => required ? theme.palette.error.main : theme.palette.text.primary }}
                >
                    {getFieldLabel(field)}
                </InputLabel>
                <OutlinedInput
                    type={show ? "TEXT" : "PASSWORD"}
                    id={'field-' + name}
                    value={value != null ? value.toString() : ''}
                    onChange={(e) => onChange(e.target.value)}
                    label={name}
                    disabled={disabled}
                    required={required}
                    error={errors.length > 0}

                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={() => { setShow(!show) }}
                                onMouseDown={() => { setShow(!show) }}
                            >
                                {show ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                        </InputAdornment>
                    }
                />
            </>
        )
    }

export default PasswordField;